import React, { useEffect, useRef, useState } from 'react';
import styles from './Input.module.scss';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

export const CustomInput = ({
  fieldName,
  customStyles,
  validateMessage = '',
  isShow,
  invalid,
  onChange,
  onFocusChanged,
  value,
  type,
  placeholder,
  name,
  disabled,
  inputClassName,
  maxLength,
  autoFocus,
  ...props
}) => {
  const [showField, setShowField] = useState(false);

  const inputRef = useRef(null);

  const handleShowToggle = () => {
    setShowField(!showField);
  };
  const { t } = useTranslation();

  useEffect(() => {
    autoFocus && inputRef?.current?.focus();
  }, [inputRef?.current]);

  return (
    <div className={cx(styles.inputFieldContainer, { [styles.password]: type === 'password' })} style={customStyles}>
      {fieldName && <p className={styles.fieldName}>{fieldName}</p>}
      <div className={styles.inputContainer}>
        <input
          ref={inputRef}
          type={showField ? 'text' : type}
          name={name}
          className={inputClassName}
          onChange={onChange}
          onBlur={onFocusChanged}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          style={{
            border: invalid ? '1px solid #E1963E' : '',
            fontFamily: 'Nunito Sans',
          }}
          {...props}
        />
        {isShow && <span onClick={handleShowToggle}>{showField ? t('general.hide_password') : t('general.show_password')}</span>}
      </div>
      {invalid && <p className={styles.validateMessage}>{validateMessage}</p>}
    </div>
  );
};
